import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { applyStoredTheme } from "@/lib/theme";
import { initOfflineStore } from "@/lib/offlineStore";

// Avant le premier rendu : évite le flash de thème sombre le temps que les
// préférences du compte reviennent du backend.
applyStoredTheme();

// Charge le manifeste du cache hors ligne (liste des images/sets déjà
// synchronisés) en mémoire. Ne bloque pas le premier rendu : tant qu'il
// n'est pas prêt, les lookups locaux échouent silencieusement et
// retombent sur le réseau (comportement d'aujourd'hui), rien ne casse.
initOfflineStore();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
